import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import Dashboard from '../views/Dashboard.vue';
import DashboardNew from '../views/DashboardNew.vue';
import Login from '../views/login/Login.vue';
//import Icon from '../views/Icon.vue';

//公共页面
const NotFound = () => import('../views/common/404.vue');
const Forbidden = () => import('../views/common/403.vue');
const ZhengcaiyunProduct = () => import('../views/huicaiyun/huicaiyunProduct.vue');
//组织机构
const DeptList = () => import('../views/organization/DeptList.vue');
const RoleList = () => import('../views/organization/RoleList.vue');
const PostList = () => import('../views/organization/PostList.vue');
const UserList = () => import('../views/organization/UserList.vue');
const Framework = () => import('../views/organization/Framework.vue');
const FrameworkPlacement = () => import('../views/organization/FrameworkPlacement.vue');
const UserNode = () => import('../views/organization/UserNode.vue')
const UserNodeCircularPermutation = () => import('../views/organization/UserNodeCircularPermutation.vue')
const Grade = () => import('../views/organization/Grade.vue');
const Agent = () => import('../views/organization/Agent.vue')
const AgentBonus = () => import('../views/organization/AgentBonus.vue')
const AgentLevel = () => import('../views/organization/AgentLevel.vue')
const UserAuth = () => import('../views/organization/UserAuth.vue')
const Currency = () => import('../views/organization/Currency.vue')
const Pay = () => import('../views/organization/Pay.vue')
const technologyManagement = () => import('../views/technologyManagement/technologyManagement.vue')
//const Permission = () => import('../views/organization/Permission.vue');

//开发辅助
const Generator = () => import('../views/generator/Generator.vue');

//系统管理
const DictTypeList = () => import('../views/system/DictTypeList.vue');
const AreaList = () => import('../views/system/AreaList.vue');
const MenuList = () => import('../views/system/MenuList.vue');
const SysConfig = () => import('../views/system/SysConfig.vue');
const LogList = () => import('../views/system/LogList.vue');
const Cronjob = () => import('../views/system/Cronjob.vue');
const Bank = () => import('../views/system/Bank.vue')
const BankCard = () => import('../views/system/BankCard.vue')

//商城模块
const Product = () => import('../views/shop/Product.vue');
const ProductCategory = () => import('../views/shop/ProductCategory.vue');
const Order = () => import('../views/shop/Order.vue');
const MoneyRecord = () => import('../views/finance/MoneyRecord.vue');
const TeamPerformance = () => import('../views/finance/TeamPerformance.vue');
const CollectRecharge = () => import('../views/finance/CollectRecharge.vue');
const CollectAdvance = () => import('../views/finance/CollectAdvance.vue');
const MoneyRelease = () => import('../views/finance/MoneyRelease.vue')
const Globalvalue = () => import('../views/finance/Globalvalue.vue')
const MoneyFlow = () => import('../views/finance/MoneyFlow.vue');
const DeliveryManagement = () => import('../views/shop/DeliveryManagement.vue');
const AfterSales = () => import('../views/shop/AfterSales.vue')
const UserMoney = () => import('../views/finance/UserMoney.vue');
const ModelIncome = () => import('../views/model/ModelIncome.vue')
const MppUserGrowth = () => import('../views/organization/MppUserGrowth.vue');
const WarningPerson = () => import('../views/finance/WarningPerson.vue');
const WarningList = () => import('../views/finance/WarningList.vue');


const ProductAdd = () => import('../views/shop/ProductAdd.vue');
const Attribute = () => import('../views/shop/Attribute.vue');
const ActivityProduct = () => import('../views/shop/ActivityProduct.vue');
const Activity = () => import('../views/shop/Activity.vue');
//内容管理
const CmsArticle = () => import('../views/cms/ArticleList.vue');
const CmsCatalog = () => import('../views/cms/CatalogList.vue');
const Workorder = () => import('../views/cms/Workorder.vue')
//券包管理
const Coupon = () => import('../views/shop/Coupon.vue');
const CouponReceive = () => import('../views/shop/CouponReceive.vue');
const ShopRedPacket = () => import('../views/shop/ShopRedPacket.vue');
const ShopCard = () => import('../views/shop/ShopCard.vue');
const MarketInteractPresent = () => import('../views/shop/MarketInteractPresent.vue')
const MarketInteractRecord = () => import('../views/shop/MarketInteractRecord.vue')
const MarketSign = () => import('../views/shop/MarketSign.vue')
const MarketTurntable = () => import('../views/shop/MarketTurntable.vue')
//评价管理
const ProductComment = () => import('../views/shop/ProductComment.vue');
//收藏管理
const PrductCollection = () => import('../views/shop/ProductCollection.vue');

//品牌管理
const ProductBrand = () => import('../views/shop/ProductBrand.vue');
//优+优选数智
const YouPlusProduct = () => import('../views/shop/YouPlusProduct.vue');
const YouPlusProductCategory = () => import('../views/shop/YouPlusProductCategory.vue');
//小程序首页品牌管理
const ProductBrandTimeList = () => import('../views/shop/ShopProductBrandTimeList.vue');
//小程序首页品牌管理
const ShopProductBrandRelationList = () => import('../views/shop/ShopProductBrandRelationList.vue');
//用户地址
const UserAddress = () => import('../views/organization/UserAddress.vue');

//即时
const New = () => import('../views/im/new.vue');

//即时通讯管理
const onlineUserList = () => import('../views/im/onlineUser.vue'); //在线用户
const friendList = () => import('../views/im/friendBox.vue'); //好友列表
const sensitiveList = () => import('../views/im/sensitiveList.vue'); //敏感词
const privateChatList = () => import('../views/im/privateChat.vue'); //私聊消息
const requestMessageList = () => import('../views/im/requestMessage.vue'); //请求消息
const systemMessagesList = () => import('../views/im/systemMessages.vue'); //系统消息
//AI
const GptApiKey = () => import('../views/AI/GptApikey.vue'); //ApiKey管理
const GptChatSession = () => import('../views/AI/GptChatSession.vue'); //会话管理
const GptChat = () => import('../views/AI/GptChat.vue'); //消息管理
//数据报表
const StatisticsMarket = () => import('@/views/statistics/StatisticsMarket.vue'); //销售统计
const StatisticsMember = () => import('@/views/statistics/StatisticsMember.vue'); //会员统计
const StatisticsVisitor = () => import('@/views/statistics/StatisticsVisitor.vue'); //访客统计
const StatementMore = () => import('@/views/statistics/StatementMore.vue')
const StatementManipulate = () => import('@/views/statistics/StatementManipulate.vue')
const ReportDaily = () => import('@/views/statistics/ReportDaily.vue');
const CustomizeReport = () => import('@/views/statistics/CustomizeReport.vue')
//店铺列表
const MallShop = () => import('@/views/mallshop/MallShop.vue');
const MallShopAdd = () => import('@/views/mallshop/MallShopAdd.vue')
const MallHotel = () => import('@/views/hotel/MallHotel.vue');
const MallHotelRoom = () => import('@/views/hotel/MallHotelRoom.vue');
const MallHotelOrder = () => import('@/views/hotel/MallHotelOrder.vue');
const MallHotelBrand = () => import('@/views/hotel/MallHotelBrand');
const MallHotelBrandCategory = () => import('@/views/hotel/MallHotelBrandCategory');
const MallHotelAdd = () => import('@/views/hotel/MallHotelAdd')
//视频管理
const VideoCollection = () => import("@/views/video/VideoCollection")
const VideoComment = () => import("@/views/video/VideoComment")
const VideoLike = () => import("@/views/video/VideoLike")
const VideoProduct = () => import("@/views/video/VideoProduct")
const VideoVideo = () => import("@/views/video/VideoVideo")
//页面装修
const DecorationIndex = () => import("@/views/decoration/DecorationIndex")
const Decoration = () => import("@/views/decoration/Decoration")
//运费管理
const FreightManagement = () => import("@/views/system/FreightManagement")
//商品团购
const ShopProductGroupbuy = () => import('@/views/shop/ShopProductGroupbuy.vue')
//文件管理
const FileFolder = () => import('@/views/system/MppFileFolder.vue')

//门店管理
const ShopStore = () => import('@/views/StoreManagement/ShopStore.vue')
const ShopStoreMap = () => import('@/views/StoreManagement/ShopStoreMap.vue')
const ShopStoreData = () => import('@/views/StoreManagement/ShopStoreData.vue')
const ShopStoreOrgInfo = () => import('@/views/StoreManagement/ShopStoreOrgInfo.vue')
const ShopStoreOrgInfoV3 = () => import('@/views/StoreManagement/ShopStoreOrgInfoV3.vue')
const bankCardManagement = () => import('@/views/StoreManagement/bankCardManagement.vue')
const quickPaymentForIncomingItems = () => import('@/views/StoreManagement/quickPaymentForIncomingItems.vue')
const hfApplication = () => import('@/views/StoreManagement/hfApplication.vue')
const ShopStoreProduct = () => import('@/views/StoreManagement/ShopStoreProduct.vue')
const AbnormalUserList = () => import('@/views/StoreManagement/AbnormalUserList.vue')

//配送管理
const ShopDeliver = () => import("@/views/StoreManagement/ShopDeliver.vue")

//操作日志
const MppLogOperate = () => import("@/views/system/MppLogOperate.vue")

//推广管理
const MppPromoter = () => import("@/views/shop/MppPromoter.vue")
//推广等级
const MppPromoterGrade = () => import("@/views/shop/MppPromoterGrade.vue")
//收款二维码
const ShopPayQrcode = () => import("@/views/shop/ShopPayQrcode.vue")
// 粉丝
const fanTreeDiagram = () => import("@/views/shop/fanTreeDiagram.vue")
//每日业绩统计
const dailyStatistics = () => import("@/views/shop/dailyStatistics.vue")
//门店分类
const ShopCategory = () => import("@/views/StoreManagement/ShopCategory.vue")
//门店订单管理
const StoreOrder = () => import("@/views/StoreManagement/StoreOrder.vue")
//洗护订单管理
const XiHuOrder = () => import("@/views/StoreManagement/XiHuOrder.vue")
//广告管理
const CmsAds = () => import("@/views/cms/CmsAds.vue")
//广告分类
const CmsAdsCategory = () => import("@/views/cms/CmsAdsCategory.vue")
//APP菜单
const MppAppMenu = () => import("@/views/system/MppAppMenu.vue")
//主题菜单
const MppAppSubject = () => import("@/views/system/MppAppSubject.vue")
//专利管理
const PropertyPatent = () => import("@/views/property/PropertyPatent.vue")
//商标管理
const PropertyTrademark = () => import("@/views/property/PropertyTrademark.vue")
//公司管理
const PropertyCompany = () => import("@/views/property/PropertyCompany.vue")
//账号列表
const AccountList = () => import("@/views/im/accountList.vue")
//禁言列表
const SilencedList = () => import("@/views/im/silencedList.vue")
//客服管理
const ImCustomer = () => import("@/views/customer/ImWebimCustomer.vue")
//客服配置
const ImSetCustomer = () => import("@/views/customer/ImWebimSetCustomer.vue")
//坐席管理
const ImSeat = () => import("@/views/customer/ImWebimSeat.vue")
//常见问题
const ImFaq = () => import("@/views/customer/ImWebimFaq.vue")
//浮窗管理
const ImFloat = () => import("@/views/customer/ImWebimFloat.vue")
//页面地址
const MppAppPage = () => import("@/views/decoration/MppAppPage.vue")
//底部菜单
const MppAppTabbar = () => import("@/views/decoration/MppAppTabbar.vue")
//登录日志
const MppLogLogin = () => import("@/views/system/MppLogLogin.vue")
//广告管理
const AdManagement = () => import("@/views/decoration/AdManagement.vue")
//主题风格
const ThemeStyle = () => import("@/views/decoration/ThemeStyle.vue")
//配置管理
const ConfigManagement = () => import("@/views/decoration/ConfigManagement.vue")
//安置管理
const ModelPlace = () => import("@/views/model/ModelPlace.vue")
//奖励管理
const ModelReward = () => import("@/views/model/ModelReward.vue")
//升级管理
const ModelUpgrade = () => import("@/views/model/ModelUpgrade.vue")
//推荐奖励
const ModelRecommend = () => import("@/views/model/ModelRewardrecomment.vue")
//我的菜单
const MppMenu = () => import("@/views/decoration/MyMenu.vue")
//次卡管理
const ShopTimescardBuy = () => import('@/views/shop/ShopTimescardBuy.vue')
//合同管理
const EsignContract = () => import("@/views/Contract/EsignContract.vue")
//签约管理
const EsignRecord = () => import("@/views/Contract/EsignRecord.vue")
//分拣管理
const ShopSorting = () => import('@/views/StoreManagement/ShopSorting.vue')
//报名列表
const McnTaskFansRecord = () => import('@/views/task/McnTaskFansRecord.vue')
//互关列表
const McnTaskFollowRecord = () => import('@/views/task/McnTaskFollowRecord.vue')
//涨粉任务
const McnTaskFans = () => import('@/views/task/McnTaskFans.vue')
//互关房间
const McnTaskFollow = () => import('@/views/task/McnTaskFollow.vue')
//授权账号
const McnAccountAuth = () => import('@/views/task/McnAccountAuth.vue')
//媒体账号
const McnAccountMedia = () => import('@/views/task/McnAccountMedia.vue')
//店铺订单
const ShopOrder = () => import('@/views/mallshop/MallShopOrder.vue')
//房间用户列表
const McnTaskFollowRoom = ()=> import('@/views/cms/McnTaskFollowRoom.vue')
//数据统计
const dataStatistics = ()=> import('@/views/dataStatistics/index.vue')

//本地商品库
const YouzhicaiLocalShopProduct = () => import('@/views/youzhicai/LocalShopProduct.vue')
//优质采商品
const YouzhicaiProduct = () => import('@/views/youzhicai/YouzhicaiProduct.vue')
//优质采商品分类
const YouzhicaiCategory = () => import('@/views/youzhicai/YouzhicaiCategory.vue')
//优质采订单列表
const YouzhicaiOrder = () => import('@/views/youzhicai/YouzhicaiOrder.vue')
// 楼层
const ShopFloor = ()=> import('@/views/shop/ShopFloor.vue')
// 订单编码
const ShopOrderCode = () => import('@/views/StoreManagement/ShopOrderCode.vue')
// 店铺分类
const ShopCategorys = () => import('@/views/shop/ShopCategory.vue')
// 拼团管理
const ShopProductGroupbuyDroup = () => import('@/views/shop/ShopProductGroupBuyGroup.vue')
// 秒杀商品
const ShopProductSeckill = () => import('@/views/shop/ShopProductSeckill.vue')
// 服务速度
const WashServiceSpeed = () => import('@/views/wash/WashServiceSpeed.vue')
// 服务设置
const WashService = () => import('@/views/wash/WashService.vue')
// 存放区域
const WashStorageArea = () => import('@/views/wash/WashStorageArea.vue')
// 物件分类
const WashProductCategory = () => import('@/views/wash/WashProductCategory.vue')
// 物件设置
const WashProduct = () => import('@/views/wash/WashProduct.vue')
// 服务价格
const WashServicePrice = () => import('@/views/wash/WashServicePrice.vue')
// 颜色设置
const WashProductColor = () => import('@/views/wash/WashProductColor.vue')
// 瑕疵设置
const WashProductFlaw = () => import('@/views/wash/WashProductFlaw.vue')
// 品牌设置
const WashProductBrand = () => import('@/views/wash/WashProductBrand.vue')
// 档次设置
const WashServiceGrade = () => import('@/views/wash/WashServiceGrade.vue')
// 配件设置
const WashProductAccessory = () => import('@/views/wash/WashProductAccessory.vue')
// 附加项目
const WashServiceAddition = () => import('@/views/wash/WashServiceAddition.vue')
// 安置设置
const ModelPlaceConfig = () => import('@/views/model/ModelPlaceConfig.vue')
// 推荐奖励设置
const ModelRecommendConfig = () => import('@/views/model/ModelRewardrecommentConfig.vue')
// 升级设置
const ModelUpgradeConfig = () => import('@/views/model/ModelUpgradeConfig.vue')
// 安置奖励设置
const ModelRewardPlaceConfig = () => import('@/views/model/ModelRewardConfig.vue')
// 房间管理
const EduCourseStream = () => import('@/views/edu/EduCourseStream.vue')


// edu
// 点播课程
const EduCourseDianBo = () => import('@/views/edu/EduCourseDianBo.vue')
// 直播课程
const EduCourseZhiBo = () => import('@/views/edu/EduCourseZhiBo.vue')
// 线下课程
const EduCourseXianXia = () => import('@/views/edu/EduCourseXianXia.vue')
// 分类
const EduCourseCategory = () => import('@/views/edu/EduCourseCategory.vue')
// 教师管理
const EduTeacher = () => import('@/views/edu/EduTeacher.vue')
// 班级管理
const EduClass = () => import('@/views/edu/EduClass.vue')
// 视频管理
const EduVideo = () => import('@/views/edu/EduCourseVideo.vue')
// 资料管理
const EduCourseMerterial = () => import('@/views/edu/EduCourseMerterial.vue')
// 习题管理
const EduExercise = () => import('@/views/edu/EduExercise.vue')
// 错题管理
const EduExerciseError = () => import('@/views/edu/EduExerciseError.vue')
// 习题分类 /edu/exampaper
const EduExerciseCategory = () => import('@/views/edu/EduExerciseCategory.vue')
// 试卷管理
const EduExamPaper = () => import('@/views/edu/EduExampaper.vue')
// 试卷分类
const EduExamPaperCategory = () => import('@/views/edu/EduExampaperCategory.vue')
// 科目管理
const EduSubject = () => import('@/views/edu/EduSubject.vue')
// 知识点管理
const EduKnowledge = () => import('@/views/edu/EduKnowledge.vue')



// 餐饮管理
const RestaurantOrder = () => import('../views/restaurant/Order.vue');
const RestaurantProduct = () => import('../views/restaurant/Product.vue');
const RestaurantProductAdd = () => import('../views/restaurant/ProductAdd.vue');
const RestaurantProductCategory = () => import('../views/restaurant/ProductCategory.vue');
const RestaurantProductBrand = () => import('../views/restaurant/ProductBrand.vue');
const RestaurantAttribute = () => import('../views/restaurant/Attribute.vue');
//收藏管理
const RestaurantPrductCollection = () => import('../views/restaurant/ProductCollection.vue');
//评价管理
const RestaurantProductComment = () => import('../views/restaurant/ProductComment.vue');
//店铺订单
const RestaurantShopOrder = () => import('@/views/restaurant/MallShopOrder.vue')
//店铺列表
const RestaurantMallShop = () => import('@/views/restaurant/MallShop.vue');
const RestaurantMallShopAdd = () => import('@/views/restaurant/MallShopAdd.vue')
// 店铺分类
const RestaurantShopCategorys = () => import('@/views/restaurant/ShopCategory.vue')
//洗护订单管理
const RestaurantXihuOrder = () => import("@/views/restaurant/XiHuOrder.vue")
//门店订单管理
const RestaurantStoreOrder = () => import("@/views/restaurant/StoreOrder.vue")
//门店管理
const RestaurantShopStore = () => import('@/views/restaurant/ShopStore.vue')
const RestaurantShopStoreProduct = () => import('@/views/restaurant/ShopStoreProduct.vue')
//门店分类
const RestaurantShopCategory = () => import("@/views/restaurant/ShopStoreCategory.vue")
//配送管理
const RestaurantDeliver = () => import("@/views/restaurant/ShopDeliver.vue")
//分拣管理
const RestaurantSorting = () => import('@/views/restaurant/ShopSorting.vue')
// 订单编码
const RestaurantOrderCode = () => import('@/views/restaurant/ShopOrderCode.vue')
// 餐馆二维码
const RestaurantShopPayQrcode = () => import('@/views/restaurant/ShopPayQrcode.vue')
// 餐饮优惠券
const RestaurantCoupon = () => import('@/views/restaurant/Coupon.vue')



// 洗护云
const WashcloudOrder = () => import('../views/washcloud/Order.vue');
const WashcloudProduct = () => import('../views/washcloud/Product.vue');
const WashcloudProductAdd = () => import('../views/washcloud/ProductAdd.vue');
const WashcloudProductCategory = () => import('../views/washcloud/ProductCategory.vue');
const WashcloudProductBrand = () => import('../views/washcloud/ProductBrand.vue');
const WashcloudAttribute = () => import('../views/washcloud/Attribute.vue');
//收藏管理
const WashcloudPrductCollection = () => import('../views/washcloud/ProductCollection.vue');
//评价管理
const WashcloudProductComment = () => import('../views/washcloud/ProductComment.vue');
//店铺订单
const WashcloudShopOrder = () => import('@/views/washcloud/MallShopOrder.vue')
//店铺列表
const WashcloudMallShop = () => import('@/views/washcloud/MallShop.vue');
const WashcloudMallShopAdd = () => import('@/views/washcloud/MallShopAdd.vue')
// 店铺分类
const WashcloudShopCategorys = () => import('@/views/washcloud/ShopCategory.vue')
//洗护订单管理
const WashcloudXihuOrder = () => import("@/views/washcloud/XiHuOrder.vue")
//门店订单管理
const WashcloudStoreOrder = () => import("@/views/washcloud/StoreOrder.vue")
//门店管理
const WashcloudShopStore = () => import('@/views/washcloud/ShopStore.vue')
const WashcloudShopStoreProduct = () => import('@/views/washcloud/ShopStoreProduct.vue')
//门店分类
const WashcloudShopCategory = () => import("@/views/washcloud/ShopStoreCategory.vue")
//配送管理
const WashcloudDeliver = () => import("@/views/washcloud/ShopDeliver.vue")
//分拣管理
const WashcloudSorting = () => import('@/views/washcloud/ShopSorting.vue')
// 订单编码
const WashcloudOrderCode = () => import('@/views/washcloud/ShopOrderCode.vue')
// 洗护优惠券
const WashcloudCoupon = () => import('@/views/washcloud/Coupon.vue')


// 接口
// 软件授权
const ApiWebAuthorize = () => import('@/views/api/ApiWebAuthorize.vue')
// 接口账号
const ApiUser = () => import('@/views/api/ApiUser.vue')
// 短信模板
const ApiSmsTemplate = () => import('@/views/api/ApiSmsTemplate.vue')
// 短信套餐
const ApiSmsPackage = () => import('@/views/api/ApiSmsPackage.vue')
// 接口类型
const ApiWebType = () => import('@/views/api/ApiWebType.vue')
//装修菜单
const AppDecorMenu = () => import("@/views/system/AppDecorMenu.vue")

// 工厂管理
const WashcloudFactory = () => import('@/views/factory/WashcloudFactory.vue')

// 网单平台工厂
const WashcloudFactoryWashcloud = () => import('@/views/platform/WashcloudPlatformFactory.vue')
// 网单平台套餐
const WashcloudPlatformProduct = () => import('@/views/platform/WashcloudPlatformProduct.vue')
// 洗衣店二维码
const WashcloudShopPayQrcode = () => import('@/views/washcloud/ShopPayQrcode.vue')

// 店铺类型
const ShopShopType = () => import('@/views/shop/ShopShopType.vue')
// 门店分类
const ShopStoreType = () => import("@/views/StoreManagement/ShopStoreType.vue")
// 门店行业
const ShopStoreIndustry = () => import("@/views/StoreManagement/ShopStoreIndustry.vue")
// 店铺行业
const ShopShopIndustry = () => import("@/views/shop/ShopShopIndustry.vue")
// 全局记录
const OperationDailyglobaldata = () => import("@/views/operation/OperationDailyGlobalData.vue")
// 活跃用户贡献值记录
const OperationDailyactiveuser = () => import("@/views/operation/OperationDailyactiveUser.vue")
// 活跃悦豆记录
const OperationDailyactivestore = () => import("@/views/operation/OperationDailyactiveStore.vue")
// 商家活动记录
const OperationDailyStoreActivity = () => import("@/views/operation/OperationDailyStoreActivity.vue")
// 不活跃贡献记录
const OperationDailyinactiveaccount = () => import("@/views/operation/OperationDailyinactiveAccount.vue")
// 悦果分配池
const OperationDailystoreplus = () => import("@/views/operation/OperationDailyStorePlus.vue")
// 代理划转限制
const AgentTransferLimit = () => import("@/views/operation/AgentTransferLimit.vue")
// 付款订单
const ShopStorepayorder = () => import("@/views/StoreManagement/ShopStorePayOrder.vue")
// 支付账单
const MppMoneypay = () => import("@/views/finance/MppMoneyPay.vue")
// 加权模拟
const WeightingData = () => import("@/views/finance/WeightingData.vue")
// 补贴凭证
const ShopIncomeVoucher = () => import("@/views/StoreManagement/ShopIncomeVoucher.vue")
// 线下补贴凭证
const shopOfflineSubsidy = () => import("@/views/StoreManagement/shopOfflineSubsidy.vue")
// 补贴工具
const ShopIncomeTool = () => import("@/views/StoreManagement/ShopIncomeTool.vue")
// 补贴记录
const ShopSubsidyrecord = () => import("@/views/finance/ShopSubsidyRecord.vue")
// 培养明细
const ShopIncomecultivate = () => import("@/views/finance/ShopIncomeCultivate.vue")
// 异常报文
// 支付异常
const paymentException = () => import("@/views/abnormalQueryMessage/paymentException.vue")
// 追付订单
const  chasePaymentOrder  = () => import("@/views/abnormalQueryMessage/chasePaymentOrder.vue")
// 追付订单
const  wholesaleGoods  = () => import("@/views/wholesaleGoods/wholesaleGoods.vue")
// 门头补贴
const  StorefrontSubsidyCom  = () => import("@/views/StorefrontSubsidyCom/StorefrontSubsidy.vue")
// 限制消费
const  ProhibitedPay  = () => import("@/views/ProhibitedPay/ProhibitedPay.vue")
Vue.use(Router);

const routes = [
    {
        path: '/',
        redirect: '/dashboard'
    },
    {
        path: '/',
        component: Home,
        meta: { title: '自述文件' },
        children: [
            {
                path: '/dashboard',
                component: DashboardNew,
                meta: { title: '系统首页' }
            },
            {
                path: '/user/userAddressList',
                component: UserAddress,
                meta: { title: '用户地址管理' }
            },
            //{
            //    path: '/icon',
            //    component: Icon,
            //    meta: { title: '自定义图标' }
            //},
            //生成代码
            {
                path: '/wholesaleGoods/wholesaleGoods',
                component: wholesaleGoods,
                meta: { title: '批发商品管理' }
            },
            {
                path: '/generator/GeneratorList',
                component: Generator,
                meta: { title: '生成代码' }
            },
            // 数据统计
            {
                path: '/dataStatistics/index',
                component: dataStatistics,
                meta: { title: '数据统计' }
            },
            // 支付异常
            {
                path: '/abnormalQueryMessage/paymentException',
                component: paymentException,
                meta: { title: '支付异常' }
            },
            // 追付订单
            {
                path: '/abnormalQueryMessage/chasePaymentOrder',
                component: chasePaymentOrder,
                meta: { title: '追付订单' }
            },
            //商城管理
            {
                path: '/shop/ShopProductBrandList',
                component: ProductBrand,
                meta: { title: '品牌管理' }
            },
            {
                path: '/shop/YouPlusProduct',
                component: YouPlusProduct,
                meta: { title: '优选数智商城商品' }
            },
            {
                path: '/shop/YouPlusProductCategory',
                component: YouPlusProductCategory,
                meta: { title: '优选数智商城分类' }
            },
            {
                path: '/shop/ShopProductBrandTimeList',
                component: ProductBrandTimeList,
                meta: { title: '首页推荐品牌' }
            },
            {
                path: '/shop/ShopProductBrandRelationList',
                component: ShopProductBrandRelationList,
                meta: { title: '首页推荐品牌' }
            },
            {
                path: '/shop/ProductList',
                component: Product,
                meta: { title: '商品列表' }
            },
            {
                path: '/shop/CategoryList',
                component: ProductCategory,
                meta: { title: '商品分类' }
            },

            {
                path: '/zhengcaiyun/ZhengcaiyunProduct',
                component: ZhengcaiyunProduct,
                meta: { title: '商品列表' }
            },
            {
                path: '/shop/OrderList',
                component: Order,
                meta: { title: '订单管理' }
            },
            {
                path: '/shop/ShopProductAdd',
                component: ProductAdd,
                meta: { title: '添加商品' }
            },
           
            {
                path: '/shop/Attribute',
                component: Attribute,
                meta: { title: '属性管理' }
            },
            {
                path: '/shop/shopProductCatalogList',
                component: ActivityProduct,
                meta: {
                    title: ''
                }
            },
            {
                path: '/shop/Activity',
                component: Activity,
                meta: {
                    title: '活动管理'
                }
            },
            //财务管理
            {
                path: '/finance/MoneyRelease',
                component: MoneyRelease,
                meta: { title: '释放详情' }
            },
            {
                path: '/finance/MoneyRecordList',
                component: MoneyRecord,
                meta: { title: '余额明细' }
            },
            {
                path: '/finance/TeamPerformance',
                component: TeamPerformance,
                meta: { title: '团队业绩' }
            },

            {
                path: '/finance/CollectRecharge',
                component: CollectRecharge,
                meta: { title: '余额充值' }
            },
            {
                path: '/finance/CollectAdvance',
                component: CollectAdvance,
                meta: { title: '余额提现' }
            },
            {
                path: '/shop/DeliveryManagement',
                component: DeliveryManagement,
                meta: { title: '发货管理' }
            },
            {
                path: '/shop/AfterSales',
                component: AfterSales,
                meta: { title: '售后管理' }
            },
            {
                path: '/finance/MoneyFlowList',
                component: MoneyFlow,
                meta: { title: '余额流水' }
            },
            {
                path: '/finance/WarningPerson',
                component: WarningPerson,
                meta: { title: '预警人员' }
            },
            {
                path: '/finance/WarningList',
                component: WarningList,
                meta: { title: '预警列表' }
            },
            {
                path: '/finance/UserMoneyList',
                component: UserMoney,
                meta: { title: '用户资产' }
            },
            {
                path: '/model/ModelIncome',
                component: ModelIncome,
                meta: { title: '分红管理' }
            },
            {
                path: '/finance/Globalvaluee',
                component: Globalvalue,
                meta: { title: '全局数据' }
            },
            //内容管理
            {
                path: '/article/articleList',
                component: CmsArticle,
                meta: { title: '文章管理' }
            },
            {
                path: '/catalog/catalogList',
                component: CmsCatalog,
                meta: { title: '目录管理' }
            },
            {
                path: '/catalog/Workorder',
                component: Workorder,
                meta: { title: '工单管理' }
            },
            //券包管理
            {
                path: '/shop/couponList',
                component: Coupon,
                meta: { title: '优惠券管理' }
            },
            {
                path: '/shop/userCouponList',
                component: CouponReceive,
                meta: { title: '优惠券领取' }
            },

            //红包管理
            {
                path: '/ShopRedPacket/ShopRedPacket',
                component: ShopRedPacket,
                meta: { title: '红包管理' }
            },
            {
                path: '/shop/ShopCard',
                component: ShopCard,
                meta: {
                    title: '卡片管理'
                }
            },
            {
                path: '/shop/MarketInteractPresent',
                component: MarketInteractPresent,
                meta: {
                    title: '互动有礼'
                }
            },
            {
                path: '/shop/MarketInteractRecord',
                component: MarketInteractRecord,
                meta: {
                    title: '互动有礼记录'
                }
            },
            {
                path: '/shop/MarketSign',
                component: MarketSign,
                meta: {
                    title: '签到记录'
                }
            },
            {
                path: '/shop/MarketTurntable',
                component: MarketTurntable,
                meta: {
                    title: '转盘管理'
                }
            },

            //评价管理
            {
                path: '/shop/CommentList',
                component: ProductComment,
                meta: { title: '评价管理' }
            },
            //收藏管理
            {
                path: '/shop/CollectionList',
                component: PrductCollection,
                meta: { title: '收藏管理' }
            },
            // 组织机构
            {
                path: '/dept/DeptList',
                component: DeptList,
                meta: { title: '部门管理' }
            },
            {
                path: '/role/RoleList',
                component: RoleList,
                meta: { title: '角色管理' }
            },
            {
                path: '/post/PostList',
                component: PostList,
                meta: { title: '岗位管理' }
            },
            {
                path: '/user/UserList',
                component: UserList,
                meta: { title: '用户管理' }
            },
            {
                path: '/technologyManagement/technologyManagement',
                component: technologyManagement,
                meta: { title: '技术管理' }
            },
            {
                path: '/mpp/usergrowth',
                component: MppUserGrowth,
                meta: { title: '成长考核' }
            },
            {
                path: '/user/userFrameworkList',
                component: Framework,
                meta: { title: '推荐关系' }
            },
            {
                path: '/user/FrameworkPlacement',
                component: FrameworkPlacement,
                meta: { title: '安置关系' }
            },
            {
                path: '/user/UserNode',
                component: UserNode,
                meta: { title: '安置关系' }
            },
            {
                path: '/user/UserNodeCircularPermutation',
                component: UserNodeCircularPermutation,
                meta: { title: '三三环排' }
            },
            {
                path: '/organization/Currency',
                component: Currency,
                meta: { title: '货币管理' }
            },
            {
                path: '/organization/Pay',
                component: Pay,
                meta: { title: '支付管理' }
            },
            {
                path: '/grade/GradeList',
                component: Grade,
                meta: { title: '等级管理' }
            },
            {
                path: '/organization/AgentLevel',
                component: AgentLevel,
                meta: { title: '代理等级' }
            },
            {
                path: '/organization/Agent',
                component: Agent,
                meta: { title: '代理管理' }
            },
            {
                path: '/organization/AgentBonus',
                component: AgentBonus,
                meta: { title: '代理分红列表' }
            },
            {
                path: '/organization/UserAuth',
                component: UserAuth,
                meta: { title: '实名认证' }
            },
            // 系统管理
            {
                path: '/dict/DictTypeList',
                component: DictTypeList,
                meta: { title: '字典管理' }
            },
            {
                path: '/menu/MenuList',
                component: MenuList,
                meta: { title: '菜单管理' }
            },
            {
                path: '/config/SysConfig',
                component: SysConfig,
                meta: { title: '系统配置' }
            },
            {
                path: '/area/AreaList',
                component: AreaList,
                meta: { title: '区域管理' }
            },
            {
                path: '/log/LogList',
                component: LogList,
                meta: { title: '日志管理' }
            },
            {
                path: '/quartz/CronjobList',
                component: Cronjob,
                meta: { title: '定时任务' }
            },
            {
                path: '/system/Bank',
                component: Bank,
                meta: { title: '银行管理' }
            },
            {
                path: '/system/BankCard',
                component: BankCard,
                meta: { title: '银行卡管理' }
            },
            //权限页面
            //{
            //    path: '/permission',
            //    //component: () => import('../views/Permission.vue'),
            //	component: Permission,
            //    meta: { title: '权限测试', permission: true }
            //},
            //公共页面
            {
                path: '/404',
                component: NotFound,
                meta: { title: '404' }
            },
            {
                path: '/403',
                component: Forbidden,
                meta: { title: '403' }
            },
            {
                path: '/im/new',
                component: New,
                meta: { title: '消息列表' }
            },
            {
                path: '/im/onlineUserList',
                component: onlineUserList,
                meta: { title: '在线用户列表' }
            },
            {
                path: '/im/friendList',
                component: friendList,
                meta: { title: '好友列表' }
            },
            {
                path: '/im/privateChatList',
                component: privateChatList,
                meta: { title: '私聊消息' }
            },
            {
                path: '/im/sensitiveList',
                component: sensitiveList,
                meta: { title: '敏感词列表' }
            },
            {
                path: '/im/requestMessageList',
                component: requestMessageList,
                meta: { title: '请求消息' }
            },
            {
                path: '/im/systemMessagesList',
                component: systemMessagesList,
                meta: { title: '系统消息' }
            },
            {
                path: '/AI/GptApiKey',
                component: GptApiKey,
                meta: { title: '账号管理' }
            },
            {
                path: '/AI/GptChatSession',
                component: GptChatSession,
                meta: { title: '会话管理' }
            },
            {
                path: '/AI/GptChat',
                component: GptChat,
                meta: { title: '消息管理' }
            },
            {
                path: '/Statistics/StatisticsMarket',
                component: StatisticsMarket,
                meta: { title: '销售统计' }
            },
            {
                path: '/Statistics/StatisticsMember',
                component: StatisticsMember,
                meta: { title: '会员统计' }
            },
            {
                path: '/Statistics/StatisticsVisitor',
                component: StatisticsVisitor,
                meta: { title: '访客统计' }
            },
            {
                path: '/Statistics/StatementMore',
                component: StatementMore,
                meta: { title: '更多报表' }
            },
            {
                path: '/Statistics/ReportDaily',
                component: ReportDaily,
                meta: { title: '数据报表' }
            },
            {
                path: '/Statistics/StatementManipulate',
                component: StatementManipulate,
                meta: { title: '报表自定义' }
            },
            {
                path: '/Statistics/CustomizeReport',
                component: CustomizeReport,
                meta: { title: '自定义报表' }
            },
            {
                path: '/MallShop/MallShop',
                component: MallShop,
                meta: { title: '店铺列表' }
            },
            {
                path: '/MallShop/MallShopAdd',
                component: MallShopAdd,
                meta: { title: '添加店铺' }
            },
            {
                path: '/Hotel/MallHotel',
                component: MallHotel,
                meta: { title: '酒店列表' }
            },
            {
                path: '/Hotel/MallHotelRoom',
                component: MallHotelRoom,
                meta: { title: '房间管理' }
            },
            {
                path: '/Hotel/MallHotelOrder',
                component: MallHotelOrder,
                meta: { title: '订单管理' }
            },
            {
                path: '/Hotel/MallHotelBrand',
                component: MallHotelBrand,
                meta: { title: '品牌管理' }
            },
            {
                path: '/Hotel/MallHotelBrandCategory',
                component: MallHotelBrandCategory,
                meta: { title: '品牌分类' }
            },
            {
                path: '/Hotel/MallHotelAdd',
                component: MallHotelAdd,
                meta: { title: '添加酒店' }
            },
            // 视频管理
            {
                path: "/Video/VideoCollection",
                component: VideoCollection,
                meta: { title: "视频收藏" }
            },
            {
                path: "/Video/VideoComment",
                component: VideoComment,
                meta: { title: "评价管理" }
            },
            {
                path: '/Video/VideoLike',
                component: VideoLike,
                meta: { title: "视频喜欢" }
            },
            {
                path: "/Video/VideoProduct",
                component: VideoProduct,
                meta: { title: "商品管理" }
            },
            {
                path: "/Video/VideoVideo",
                component: VideoVideo,
                meta: { title: "视频管理" }
            },
            //页面装修
            {
                path: "/Decoration/DecorationIndex",
                component: DecorationIndex,
                meta: { title: "首页装修" }
            },
            {
                path: "/Decoration/Decoration",
                component: Decoration,
                meta: { title: "装修操作" }
            },
            //运费模板
            {
                path: "/system/FreightManagement",
                component: FreightManagement,
                meta: { title: "运费模板" }
            },
            //商品团购
            {
                path: "/shop/productgroupbuy",
                component: ShopProductGroupbuy,
                meta: { title: "团购商品" }
            },
            //文件管理
            {
                path: "/mpp/filefolder",
                component: FileFolder,
                meta: { title: "文件管理" }
            },
            //门店管理ShopStoreOrgInfo ShopStoreData
            {
                path: "/shop/store",
                component: ShopStore,
                meta: { title: "门店列表" }
            },
            {
                path: "/shop/shopstoremap",
                component: ShopStoreMap,
                meta: {title: "门店地图"}
            },
            {
                path: "/shop/shopstoredata",
                component: ShopStoreData,
                meta: { title: "门店数据" }
            },
            {
                path: "/shop/orginfo",
                component: ShopStoreOrgInfo,
                meta: { title: "门店进件" }
            },
            {
                path: "/shop/orginfoV3",
                component: ShopStoreOrgInfoV3,
                meta: { title: "门店进件V3" }
            },
            {
                path: "/StoreManagement/quickPaymentForIncomingItems",
                component: quickPaymentForIncomingItems,
                meta: { title: "快付进件" }
            },
            {
                path: "/StoreManagement/hfApplication",
                component: hfApplication,
                meta: { title: "汇付进件" }
            },
            {
                path: "/StoreManagement/bankCardManagement",
                component: bankCardManagement,
                meta: { title: "银行卡管理" }
            },
            {
                path: "/shop/storeproduct",
                component: ShopStoreProduct,
                meta: { title: "门店商品" }
            },
            // 配送管理
            {
                path: "/shop/deliver",
                component: ShopDeliver,
                meta: { title: "配送管理" }
            },
            // 操作日志
            {
                path: "/mpp/logoperate",
                component: MppLogOperate,
                meta: { title: "操作日志" }
            },
            // 推广等级
            {
                path: "/mpp/promoter",
                component: MppPromoter,
                meta: { title: "推广管理" }
            },
            // 推广管理
            {
                path: "/mpp/promotergrade",
                component: MppPromoterGrade,
                meta: { title: "推广等级" }
            },
            // 收款二维码
            {
                path: "/shop/payqrcode",
                component: ShopPayQrcode,
                meta: { title: "收款二维码" }
            },
            // 粉丝
            {
                path: "/shop/fanTreeDiagram",
                component: fanTreeDiagram,
                meta: { title: "粉丝" }
            },
            // 粉丝
            {
                path: "/shop/dailyStatistics",
                component: dailyStatistics,
                meta: { title: "业绩" }
            },
            // 门店分类
            {
                path: "/shop/storeproductcategory",
                component: ShopCategory,
                meta: { title: "商品分类" }
            },
            // 订单管理
            {
                path: "/store/order",
                component: StoreOrder,
                meta: { title: "订单管理" }
            },
            // 洗护订单管理
            {
                path: "/xihu/order",
                component: XiHuOrder,
                meta: { title: "订单管理" }
            },
            // 广告管理
            {
                path: "/cms/ads",
                component: CmsAds,
                meta: { title: "广告管理" }
            },
            // 广告分类
            {
                path: "/cms/adscategory",
                component: CmsAdsCategory,
                meta: { title: "广告分类" }
            },
            // APP菜单
            {
                path: "/mpp/appmenu",
                component: MppAppMenu,
                meta: { title: "APP菜单" }
            },
            // 主题管理
            {
                path: "/mpp/appsubject",
                component: MppAppSubject,
                meta: { title: "主题管理" }
            },
            // 专利管理
            {
                path: "/property/patent",
                component: PropertyPatent,
                meta: { title: "专利管理" }
            },
            // 商标管理
            {
                path: "/property/trademark",
                component: PropertyTrademark,
                meta: { title: "商标管理" }
            },
            // 公司管理
            {
                path: "/property/company",
                component: PropertyCompany,
                meta: { title: "公司管理" }
            },
            // 账号管理
            {
                path: '/im/account',
                component: AccountList,
                meta: { title: '账号列表' }
            },
            // 禁言列表
            {
                path: 'im/silenced',
                component: SilencedList,
                meta: { title: '禁言列表' }
            },
            // 客服管理
            {
                path: '/im/webimcustomer',
                component: ImCustomer,
                meta: { title: '客服管理' }
            },
            // 客服配置
            {
                path: '/im/websetimcustomer',
                component: ImSetCustomer,
                meta: { title: '客服配置' }
            },
            // 坐席管理
            {
                path: '/im/webimseat',
                component: ImSeat,
                meta: { title: '坐席管理' }
            },
            // 常见问题
            {
                path: '/im/webimfaq',
                component: ImFaq,
                meta: { title: '常见问题' }
            },
            // 浮窗管理
            {
                path: '/im/webimfloat',
                component: ImFloat,
                meta: { title: '浮窗管理' }
            },
            // 页面地址
            {
                path: '/mpp/apppage',
                component: MppAppPage,
                meta: { title: '页面地址' }
            },
            // 底部菜单
            {
                path: '/mpp/apptabbar',
                component: MppAppTabbar,
                meta: { title: '底部菜单' }
            },
            // 登录日志
            {
                path: '/mpp/loglogin',
                component: MppLogLogin,
                meta: { title: '登录日志' }
            },
            // 广告管理
            {
                path: '/Decoration/AdManagement',
                component: AdManagement,
                meta: { title: '广告管理' }
            },
            // 主题风格
            {
                path: '/Decoration/ThemeStyle',
                component: ThemeStyle,
                meta: { title: '主题风格' }
            },
            // 配置管理
            {
                path: '/Decoration/ConfigManagement',
                component: ConfigManagement,
                meta: { title: '配置管理' }
            },
            // 我的菜单
            {
                path: '/mpp/mymenu',
                component: MppMenu,
                meta: { title: '我的菜单' }
            },
            // 次卡管理
            {
                path: '/shop/timescardbuy',
                component: ShopTimescardBuy,
                meta: { title: '次卡管理' }
            },
            // 合同管理
            {
                path: '/esign/contract',
                component: EsignContract,
                meta: { title: '合同管理' }
            },
            // 签约管理
            {
                path: '/esign/record',
                component: EsignRecord,
                meta: { title: '签约管理' }
            },
            // 分拣管理
            {
                path: '/shop/sorting',
                component: ShopSorting,
                meta: { title: '分拣管理' }
            },
            // 报名列表
            {
                path: '/mcn/fansrecord',
                component: McnTaskFansRecord,
                meta: { title: '报名列表' }
            },
            // 互关列表
            {
                path: '/mcn/followrecord',
                component: McnTaskFollowRecord,
                meta: { title: '互关列表' }
            },
            // 涨粉任务
            {
                path: '/mcn/fans',
                component: McnTaskFans,
                meta: { title: '涨粉任务' }
            },
            // 互关房间
            {
                path: '/mcn/follow',
                component: McnTaskFollow,
                meta: { title: '互关房间' }
            },
            // 授权账号
            {
                path: '/mcn/accountauth',
                component: McnAccountAuth,
                meta: { title: '授权账号' }
            },
            // 媒体账号
            {
                path: '/mcn/accountmedia',
                component: McnAccountMedia,
                meta: { title: '媒体账号' }
            },
            // 店铺订单
            {
                path: '/mallshop/shoporder',
                component: ShopOrder,
                meta: { title: '店铺订单' }
            },
            // 房间用户列表
            {
                path: '/mcn/taskfollowroom',
                component: McnTaskFollowRoom,
                meta: { title: '房间用户列表' }
            },
            // 本地商品库
            {
                path: '/youzhicai/localshopproduct',
                component: YouzhicaiLocalShopProduct,
                meta: { title: '本地商品库' }
            },
            // 优质采商品
            {
                path: '/youzhicai/youzhicaiproduct',
                component: YouzhicaiProduct,
                meta: { title: '优质采商品' }
            },
            // 优质采商品分类
            {
                path: '/youzhicai/youzhicaicategory',
                component: YouzhicaiCategory,
                meta: { title: '优质采商品分类' }
            },
            {
                path: '/youzhicai/order',
                component: YouzhicaiOrder,
                meta: { title: '优质采订单' }
            },
            // 楼层
            {
                path: '/shop/floor',
                component: ShopFloor,
                meta: { title: '楼层活动' }
            },
            // 订单编码
            {
                path: '/shop/ordercode',
                component: ShopOrderCode,
                meta: { title: '订单编码' }
            },
            // 店铺分类
            {
                path: '/shop/productcategory',
                component: ShopCategorys,
                meta: { title: '商品分类' }
            },
            // 拼团管理
            {
                path: '/shop/productgroupbuygroup',
                component: ShopProductGroupbuyDroup,
                meta: { title: '拼团管理' }
            },
            // 秒杀商品
            {
                path: '/shop/productseckill',
                component: ShopProductSeckill,
                meta: { title: '秒杀商品' }
            },
            // 服务速度
            {
                path: '/wash/servicespeed',
                component: WashServiceSpeed,
                meta: { title: '服务速度' }
            },
            // 服务设置
            {
                path: '/wash/washservice',
                component: WashService,
                meta: { title: '服务设置' }
            },
            // 存放区域
            {
                path: '/wash/storagearea',
                component: WashStorageArea,
                meta: { title: '存放区域' }
            },
            // 物件分类
            {
                path: '/wash/productcategory',
                component: WashProductCategory,
                meta: { title: '物件分类' }
            },
            // 物件设置
            {
                path: '/wash/product',
                component: WashProduct,
                meta: { title: '物件设置' }
            },
            // 服务价格
            {
                path: '/wash/serviceprice',
                component: WashServicePrice,
                meta: { title: '服务价格' }
            },
            // 颜色设置
            {
                path: '/wash/productcolor',
                component: WashProductColor,
                meta: { title: '颜色设置' }
            },
            // 瑕疵设置
            {
                path: '/wash/productflaw',
                component: WashProductFlaw,
                meta: { title: '瑕疵设置' }
            },
            // 品牌设置
            {
                path: '/wash/productbrand',
                component: WashProductBrand,
                meta: { title: '品牌设置' }
            },
            // 档次配置
            {
                path: '/wash/servicegrade',
                component: WashServiceGrade,
                meta: { title: '档次配置' }
            },
            // 配件设置
            {
                path: '/wash/productaccessory',
                component: WashProductAccessory,
                meta: { title: '配件设置' }
            },
            // 附加项目
            {
                path: '/wash/serviceaddition',
                component: WashServiceAddition,
                meta: { title: '附加项目' }
            },
			// 安置管理
			{
			    path: '/model/place',
			    component: ModelPlace,
			    meta: { title: '广告位管理' }
			},
			// 奖励管理
			{
			    path: '/model/reward',
			    component: ModelReward,
			    meta: { title: '奖励管理' }
			},
			// 升级管理
			{
			    path: '/model/upgrade',
			    component: ModelUpgrade,
			    meta: { title: '升级管理' }
			},
			// 推荐奖励
			{
			    path: '/model/rewardrecommend',
			    component: ModelRecommend,
			    meta: { title: '推荐奖励' }
			},
            // 安置设置
            {
                path: '/model/placeConfig',
                component: ModelPlaceConfig,
                meta: { title: '安置设置' }
            },
            // 推荐奖励设置
            {
                path: '/model/rewardrecommendConfig',
                component: ModelRecommendConfig,
                meta: { title: '推荐奖励设置' }
            },
            // 升级设置
            {
                path: '/model/upgradeConfig',
                component: ModelUpgradeConfig,
                meta: { title: '升级设置' }
            },
            // 安置奖励设置
            {
                path: '/model/rewardConfig',
                component: ModelRewardPlaceConfig,
                meta: { title: '安置奖励设置' }
            },
            // 门店行业分类
            {
                path: '/shop/storeindustry',
                component: ShopStoreIndustry,
                meta: { title: '行业分类' }
            },
            // 店铺行业分类
            {
                path: '/shop/shopindustry',
                component: ShopShopIndustry,
                meta: { title: '行业分类' }
            },
            // 全局记录
            {
                path: '/operation/dailyglobaldata',
                component: OperationDailyglobaldata,
                meta: { title: '全局记录' }
            },
            // 活跃用户贡献值记录
            {
                path: '/operation/dailyactiveuser',
                component: OperationDailyactiveuser,
                meta: { title: '活跃用户贡献值记录' }
            },
            // 活跃悦豆记录
            {
                path: '/operation/dailyactivestore',
                component: OperationDailyactivestore,
                meta: { title: '活跃悦豆记录' }
            },
            // 商家活动记录
            {
                path: '/operation/dailystoreactivity',
                component: OperationDailyStoreActivity,
                meta: { title: '商家活动记录' }
            },
            // 不活跃贡献记录
            {
                path: '/operation/dailyinactiveaccount',
                component: OperationDailyinactiveaccount,
                meta: { title: '不活跃贡献记录' }
            },
            // 悦果分配池
            {
                path: '/operation/dailystoreplus',
                component: OperationDailystoreplus,
                meta: { title: '悦果分配池' }
            },
            // 代理划转限制
            {
                path: '/operation/agenttransferlimit',
                component: AgentTransferLimit,
                meta: { title: '代理划转限制' }
            },
            // 付款订单
            {
                path: '/shop/storepayorder',
                component: ShopStorepayorder,
                meta: { title: '付款订单' }
            },
            // 异常用户列表
            {
                path: '/StoreManagement/abnormalUserList',
                component: AbnormalUserList,
                meta: { title: '异常用户列表' }
            },
            // 支付账单
            {
                path: '/mpp/moneypay',
                component: MppMoneypay,
                meta: { title: '支付账单' }
            },
            {
                path: '/mpp/weightingmony',
                component: WeightingData,
                meta: { title: '加权模拟' }
            },


            // edu
            // 点播课程
            {
                path: '/edu/dianbo',
                component: EduCourseDianBo,
                meta: { title: '点播课程' }
            },
            // 直播课程
            {
                path: '/edu/zhibo',
                component: EduCourseZhiBo,
                meta: { title: '直播课程' }
            },
            // 线下课程
            {
                path: '/edu/xianxia',
                component: EduCourseXianXia,
                meta: { title: '线下课程' }
            },
            // 课程分类
            {
                path: '/edu/coursecategory',
                component: EduCourseCategory,
                meta: { title: '线下课程' }
            },
            // 教师管理
            {
                path: '/edu/teacher',
                component: EduTeacher,
                meta: { title: '教师管理' }
            },
            // 班级管理
            {
                path: '/edu/class',
                component: EduClass,
                meta: { title: '班级管理' }
            },
            // 视频管理
            {
                path: '/edu/coursevideo',
                component: EduVideo,
                meta: { title: '视频管理' }
            },
            // 资料管理
            {
                path: '/edu/coursemerterial',
                component: EduCourseMerterial,
                meta: { title: '资料管理' }
            },
            // 房间管理
            {
                path: '/edu/coursestream',
                component: EduCourseStream,
                meta: { title: '房间管理' }
            },
            // 习题管理
            {
                path: '/edu/exercise',
                component: EduExercise,
                meta: { title: '习题管理' }
            },
            // 错题管理
            {
                path: '/edu/exerciseerror',
                component: EduExerciseError,
                meta: { title: '错题管理' }
            },
            // 习题分类
            {
                path: '/edu/exercisecategory',
                component: EduExerciseCategory,
                meta: { title: '习题分类' }
            },
            // 试卷管理
            {
                path: '/edu/exampaper',
                component: EduExamPaper,
                meta: { title: '试卷管理' }
            },
            // 试卷分类
            {
                path: '/edu/exampapercategory',
                component: EduExamPaperCategory,
                meta: { title: '试卷分类' }
            },
            // 科目管理
            {
                path: '/edu/subject',
                component: EduSubject,
                meta: { title: '科目管理' }
            },
            // 知识点管理
            {
                path: '/edu/knowledge',
                component: EduKnowledge,
                meta: { title: '知识点管理' }
            },
            // 软件授权
            {
                path: '/mpp/apiwebauthorize',
                component: ApiWebAuthorize,
                meta: { title: '软件授权' }
            },
            // 接口账号
            {
                path: '/mpp/apiuser',
                component: ApiUser,
                meta: { title: '接口账号' }
            },
            // 短信模板
            {
                path: '/mpp/apismstemplate',
                component: ApiSmsTemplate,
                meta: { title: '短信模板' }
            },
            // 短信套餐
            {
                path: '/mpp/apismspackage',
                component: ApiSmsPackage,
                meta: { title: '短信套餐' }
            },
            // 接口类型
            {
                path: '/mpp/apiwebtype',
                component: ApiWebType,
                meta: { title: '接口类型' }
            },
            // 装修菜单
            {
                path: '/mpp/appdecormenu',
                component: AppDecorMenu,
                meta: { title: '装修菜单' }
            },
            // 店铺分类
            {
                path: '/shop/shoptype',
                component: ShopShopType,
                meta: { title: '店铺分类' }
            },
            // 门店类型
            {
                path: '/shop/storetype',
                component: ShopStoreType,
                meta: { title: '门店类型' }
            },
            // 工厂管理
            {
                path: '/washcloud/factory',
                component: WashcloudFactory,
                meta: { title: '工厂管理' }
            },
            // 网单平台工厂
            {
                path: '/washcloud/platformfactory',
                component: WashcloudFactoryWashcloud,
                meta: { title: '网单平台工厂' }
            },
            // 网单平台套餐
            {
                path: '/washcloud/platformproduct',
                component: WashcloudPlatformProduct,
                meta: { title: '网单平台套餐' }
            },
            // 餐饮优惠券
            {
                path: '/washcloud/couponList',
                component: WashcloudCoupon,
                meta: { title: '餐饮优惠券' }
            },





            // 餐饮管理
            {
                path: '/restaurant/orderList',
                component: RestaurantOrder,
                meta: { title: '订单管理' }
            },
            {
                path: '/restaurant/ProductList',
                component: RestaurantProduct,
                meta: { title: '商品列表' }
            },
            {
                path: '/restaurant/ShopProductAdd',
                component: RestaurantProductAdd,
                meta: { title: '添加商品' }
            },
            {
                path: '/restaurant/CategoryList',
                component: RestaurantProductCategory,
                meta: { title: '商品分类' }
            },
            {
                path: '/restaurant/ShopProductBrandList',
                component: RestaurantProductBrand,
                meta: { title: '品牌管理' }
            },
            {
                path: '/restaurant/Attribute',
                component: RestaurantAttribute,
                meta: { title: '属性管理' }
            },
            //收藏管理
            {
                path: '/restaurant/CollectionList',
                component: RestaurantPrductCollection,
                meta: { title: '收藏管理' }
            },
            //评价管理
            {
                path: '/restaurant/CommentList',
                component: RestaurantProductComment,
                meta: { title: '评价管理' }
            },
            // 店铺订单
            {
                path: '/restaurant/shoporder',
                component: RestaurantShopOrder,
                meta: { title: '店铺订单' }
            },
            {
                path: '/restaurant/MallShop',
                component: RestaurantMallShop,
                meta: { title: '店铺列表' }
            },
            {
                path: '/restaurant/MallShopAdd',
                component: RestaurantMallShopAdd,
                meta: { title: '添加店铺' }
            },
            // 店铺分类
            {
                path: '/restaurant/productcategory',
                component: RestaurantShopCategorys,
                meta: { title: '商品分类' }
            },
            // 洗护订单管理
            {
                path: "/restaurantXihu/order",
                component: RestaurantXihuOrder,
                meta: { title: "订单管理" }
            },
            // 订单管理
            {
                path: "/restaurant/order",
                component: RestaurantStoreOrder,
                meta: { title: "订单管理" }
            },
            //门店管理
            {
                path: "/restaurant/store",
                component: RestaurantShopStore,
                meta: { title: "门店列表" }
            },
            {
                path: "/restaurant/storeproduct",
                component: RestaurantShopStoreProduct,
                meta: { title: "门店商品" }
            },
            // 门店分类
            {
                path: "/restaurant/storeproductcategory",
                component: RestaurantShopCategory,
                meta: { title: "商品分类" }
            },
            // 配送管理
            {
                path: "/restaurant/deliver",
                component: RestaurantDeliver,
                meta: { title: "配送管理" }
            },
            // 分拣管理
            {
                path: '/restaurant/sorting',
                component: RestaurantSorting,
                meta: { title: '分拣管理' }
            },
            // 订单编码
            {
                path: '/restaurant/ordercode',
                component: RestaurantOrderCode,
                meta: { title: '订单编码' }
            },
            // 餐馆二维码
            {
                path: '/restaurant/payqrcode',
                component: RestaurantShopPayQrcode,
                meta: { title: '餐馆二维码' }
            },
            // 餐饮优惠券
            {
                path: '/restaurant/couponList',
                component: RestaurantCoupon,
                meta: { title: '餐饮优惠券' }
            },




            // 洗护云
            {
                path: '/washcloud/orderList',
                component: WashcloudOrder,
                meta: { title: '订单管理' }
            },
            {
                path: '/washcloud/ProductList',
                component: WashcloudProduct,
                meta: { title: '商品列表' }
            },
            {
                path: '/washcloud/ShopProductAdd',
                component: WashcloudProductAdd,
                meta: { title: '添加商品' }
            },
            {
                path: '/washcloud/CategoryList',
                component: WashcloudProductCategory,
                meta: { title: '商品分类' }
            },
            {
                path: '/washcloud/ShopProductBrandList',
                component: WashcloudProductBrand,
                meta: { title: '品牌管理' }
            },
            {
                path: '/washcloud/Attribute',
                component: WashcloudAttribute,
                meta: { title: '属性管理' }
            },
            //收藏管理
            {
                path: '/washcloud/CollectionList',
                component: WashcloudPrductCollection,
                meta: { title: '收藏管理' }
            },
            //评价管理
            {
                path: '/washcloud/CommentList',
                component: WashcloudProductComment,
                meta: { title: '评价管理' }
            },
            // 店铺订单
            {
                path: '/washcloud/shoporder',
                component: WashcloudShopOrder,
                meta: { title: '店铺订单' }
            },
            {
                path: '/washcloud/MallShop',
                component: WashcloudMallShop,
                meta: { title: '店铺列表' }
            },
            {
                path: '/washcloud/MallShopAdd',
                component: WashcloudMallShopAdd,
                meta: { title: '添加店铺' }
            },
            // 店铺分类
            {
                path: '/washcloud/productcategory',
                component: WashcloudShopCategorys,
                meta: { title: '商品分类' }
            },
            // 洗护订单管理
            {
                path: "/washcloudXihu/order",
                component: WashcloudXihuOrder,
                meta: { title: "订单管理" }
            },
            // 订单管理
            {
                path: "/washcloud/order",
                component: WashcloudStoreOrder,
                meta: { title: "订单管理" }
            },
            //门店管理
            {
                path: "/washcloud/store",
                component: WashcloudShopStore,
                meta: { title: "门店列表" }
            },
            {
                path: "/washcloud/storeproduct",
                component: WashcloudShopStoreProduct,
                meta: { title: "门店商品" }
            },
            // 门店分类
            {
                path: "/washcloud/storeproductcategory",
                component: WashcloudShopCategory,
                meta: { title: "商品分类" }
            },
            // 配送管理
            {
                path: "/washcloud/deliver",
                component: WashcloudDeliver,
                meta: { title: "配送管理" }
            },
            // 分拣管理
            {
                path: '/washcloud/sorting',
                component: WashcloudSorting,
                meta: { title: '分拣管理' }
            },
            // 订单编码
            {
                path: '/washcloud/ordercode',
                component: WashcloudOrderCode,
                meta: { title: '订单编码' }
            },
            // 洗衣店二维码
            {
                path: '/washcloud/payqrcode',
                component: WashcloudShopPayQrcode,
                meta: { title: '洗衣店二维码' }
            },
            // 补贴凭证
            {
                path: '/shop/incomevoucher',
                component: ShopIncomeVoucher,
                meta: { title: '补贴凭证' }
            },
            // 线下补贴凭证
            {
                path: '/StoreManagement/shopOfflineSubsidy',
                component: shopOfflineSubsidy,
                meta: { title: '补贴凭证' }
            },
            // 补贴工具
            {
                path: '/shop/ShopIncomeTool',
                component: ShopIncomeTool,
                meta: { title: '补贴工具' }
            },
            // 补贴记录
            {
                path: '/shop/subsidyrecord',
                component: ShopSubsidyrecord,
                meta: { title: '补贴记录' }
            },
            // 培养明细
            {
                path: '/shop/incomecultivate',
                component: ShopIncomecultivate,
                meta: { title: '培养明细' }
            },
             // 门头补贴
             {
                path: '/StorefrontSubsidyCom/StorefrontSubsidy',
                component: StorefrontSubsidyCom,
                meta: { title: '门头补贴' }
            },
             // 限制消费
             {
                path: '/ProhibitedPay/ProhibitedPay',
                component: ProhibitedPay,
                meta: { title: '限制消费' }
            },
        ]
    },
    {
        path: '/login',
        component: Login,
        meta: { title: '登录' }
    },
    {
        path: '*',
        redirect: '/404'
    }
];

export default new Router({
    routes: routes
});
